<template>
  <div class="gtc-multi-select">
    <select ref="multiSelect" :multiple="multiple" :disabled="fromDisabled" v-bind="$attrs" class="d-none" :class="selectClass">
      <option v-for="(option, index) in options" :value="index">
        <template v-if="_.trim(option[textField]) == ''">
          -- Please Select --
        </template>
        <template v-else>
          {{ option[textField] }}
        </template>
      </option>
    </select>
  </div>
</template>

<script>
  export default {
    name: 'gtc-multi-select',
    inheritAttrs: false,
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      value: {
        type: [Array, Object, String, Number],
        // default: []
      },
      options: {
        type: Array,
        default: []
      },
      keyField: {
        type: String
      },
      textField: {
        type: String,
        default: 'text'
      },
      valueField: {
        type: String,
        default: null
      },
      multiple: {
        type: Boolean,
        default: true
      },
      selectClass: {
        default: null
      },
      up: {
        type: Boolean,
        default: false
      },
    },
    data: function () {
      return {
        fns: []
      }
    },
    watch: {
      value(newVal, oldVal) {
        /* 監視 value 值，當 Parent 變更時，自動同步至 Sumoselect */
        let self = this;

        if (_.isNil(self.options) || self.options.length == 0) return;

        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) self.updateValueToSumo(newVal);
      }
    },
    computed: {
      fromDisabled: function () {
        if (this.disabled) return true;

        let hasData = _.isEmpty(this.options);
        if (hasData) return true;
      },
      fromSelectClass: function () {
        if (typeof this.selectClass == 'object') {
          var ary = [];
          _.forEach(this.selectClass, function (value, key) {
            if (value) ary.push(key)
          });
          return ary.join(' ');
        }
        if (typeof this.selectClass == 'string') {
          return this.selectClass;
        }
      }
    },
    created: function () {

    },
    mounted: function () {
      let self = this;
      let selector = $(self.$refs.multiSelect);
      selector.SumoSelect({ okCancelInMulti: false, up: self.up, selectAll: self.multiple, search: true, csvDispCount: 1 });

      let captionCont = selector.next('.CaptionCont');
      if (captionCont.length > 0) {
        captionCont.addClass(self.fromSelectClass).addClass('form-control').removeClass('SumoUnder')
      }

      self.updateValueToSumo(self.value);

      let lazyObj;

      selector.on('sumo:closed', function (sumo) {

        clearTimeout(lazyObj)

        lazyObj = setTimeout(() => {
          var result = [];
          _.forEach(selector.find(':selected'), (option, key) => {
            result.push(self.options[option.value])
          })

          if (!self.multiple) {
            if (result.length > 0)
              result = result[0];
            else
              result = null;
          }

          if (!_.isNil(result) && !_.isNil(self.valueField) && _.trim(self.valueField) !== '') {
            if (self.multiple) {
              result = _.map(result, self.valueField);
            }
            else {
              result = result[self.valueField];
            }
          }

          if (JSON.stringify(self.value) !== JSON.stringify(result)) {
            self.$emit('input', result);
            self.$emit('change', result);
            self.$emit('blur', result);
          }

        }, 100)

      });
    },
    updated: function () {
      let self = this;
      self.$refs.multiSelect.sumo.reload();

      let selector = $(self.$refs.multiSelect);

      let captionCont = selector.next('.CaptionCont');
      if (captionCont.length > 0) {
        captionCont.addClass(self.fromSelectClass).addClass('form-control').removeClass('SumoUnder')
      }

      self.updateValueToSumo(self.value);
      //selector.trigger('change');
    },
    methods: {
      clearSumo(selector) {
        this.fns.push(() => { selector.sumo.unSelectAll(); });
      },
      setSumo(selector, index) {
        this.fns.push(() => { selector.sumo.selectItem(_.toString(index)); });
      },
      update() {
        let self = this;
        setTimeout(() => {
          for (var i = 0; i < self.fns.length; i++) {
            self.fns[i]();
          }
          self.fns = [];
        }, 100);
      },
      updateValueToSumo(newVal) {
        let self = this;
        let index = -1;

        let selector = self.$refs.multiSelect;
        if (!_.isNil(selector.sumo)) {

          if (_.isNil(newVal)) {
            return;
          }

          if (self.multiple) {
            self.clearSumo(selector);
            _.forEach(newVal, item => {
              if (!_.isNil(self.valueField) && _.trim(self.valueField) !== '') {
                index = _.findIndex(self.options, [self.valueField, item]);
                if (index > -1) self.setSumo(selector, index)
              }
              else {
                let index = -1;
                if (_.trim(self.keyField || '') !== '') {
                  index = _.findIndex(self.options, [self.keyField, item[self.keyField]]);
                }
                else {
                  index = _.indexOf(self.options, item);
                }

                if (index > -1) self.setSumo(selector, index)
              }
            });

          }
          else {
            if (!_.isNil(self.valueField) && _.trim(self.valueField) !== '') {
              index = _.findIndex(self.options, [self.valueField, newVal]);
              if (index > -1) self.setSumo(selector, index)
            }
            else {
              index = -1;
              if (_.trim(self.keyField || '') !== '') {
                if (!_.isNil(newVal[self.keyField])) {
                  index = _.findIndex(self.options, [self.keyField, newVal[self.keyField]]);
                }
              }
              else {
                index = _.indexOf(self.options, newVal);
              }
              if (index > -1) self.setSumo(selector, index)
            }

            if (index < 0) {
              self.setSumo(selector, 0);
              //$(selector).trigger('change');
            }

          }

          self.update();
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/framework/GtcMultiSelect.vue